import { render, staticRenderFns } from "./StationType.vue?vue&type=template&id=58aca6b0&"
import script from "./StationType.vue?vue&type=script&lang=ts&"
export * from "./StationType.vue?vue&type=script&lang=ts&"
import style0 from "./StationType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports